import { FC } from 'react'

import { useTranslation } from 'react-i18next'
import { RouteChildrenProps } from 'react-router-dom'

import { ContactDetailsForm } from '@ana/shared'
import PageLayout from 'components/PageLayout'
import usePage from 'hooks/usePage'
import useSaveOnBack from 'hooks/useSaveOnBack'

const ContactDetailsPage: FC<RouteChildrenProps> = () => {
  const { onBack, onSubmit, initialValues = {} } = usePage()
  const formikRef = useSaveOnBack({ onBack })
  const { t } = useTranslation()

  return (
    <PageLayout title={t('category.general_information')} subtitle={t('subcategory.contact_details')}>
      <ContactDetailsForm onSubmit={onSubmit} loading={false} innerRef={formikRef} initialValues={initialValues} />
    </PageLayout>
  )
}

export default ContactDetailsPage
